// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1HEL_","large":"styles_large__Jb1oa"};